import moment from "moment";
import PropTypes from "prop-types";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { useTranslation } from "react-i18next";

const OnboardingInfo = ({ locals, setOnboardingInfo }) => {
  const { t } = useTranslation("athlete-portal");
  const { athlete, onboardingQuestionnaire, workflows } = locals;

  const joinedAt = moment(athlete?.joinedAt);

  // moved up cuz it can be filled by stopped trainig or something
  if (onboardingQuestionnaire) {
    return (
      <article
        className="onboarding-card"
        onClick={() => {
          setOnboardingInfo(onboardingQuestionnaire);
        }}
      >
        <div>
          <div className="chip success">{t("onboardingInfo.completed")}</div>

          <SvgIcon src={"/img/new-icons/arrow-right.svg"} />
        </div>
        <p className="s1">{t("onboardingInfo.title")}</p>
        <p className="p5">
          {t("onboardingInfo.completedDescription")}
        </p>
      </article>
    );
  }

  // Cuz the onboarding is gonna release in like Feb 11 or something lol
  if (joinedAt.isBefore(moment("2025-01-01"))) {
    return null;
  }

  if (
    !(
      workflows.length > 0 &&
      workflows.find((workflow) => workflow.access === "pull")
    )
  ) {
    return (
      <article
        className="onboarding-card"
        onClick={() => {
          submit("/coaching-portal/custom-workflows", {
            body: {
              access: "pull",
            },
          });
        }}
      >
        <div>
          <div className="chip info">{t("onboardingInfo.createNow")}</div>

          <SvgIcon src={"/img/new-icons/arrow-right.svg"} />
        </div>
        <p className="s1">{t("onboardingInfo.title")}</p>
        <p className="p5">
          {t("onboardingInfo.createDescription")}
        </p>
      </article>
    );
  }

  if (!onboardingQuestionnaire) {
    return (
      <article
        className="onboarding-card"
        onClick={() => {
          submit("/coaching-portal/custom-workflows", {
            body: {
              access: "pull",
              workflow: workflows.find((workflow) => workflow.access === "pull")
                ._id,
              type: "getting-started",
            },
          });
        }}
      >
        <div>
          <div className="chip warning">{t("onboardingInfo.pending")}</div>

          <SvgIcon src={"/img/new-icons/arrow-right.svg"} />
        </div>
        <p className="s1">{t("onboardingInfo.title")}</p>
        <p className="p5">
          {t("onboardingInfo.createDescription")}
        </p>
      </article>
    );
  }

  return null;
};

OnboardingInfo.propTypes = {
  locals: PropTypes.object,
};

export default OnboardingInfo;
